import React from 'react';
import styled from 'styled-components';

import SearchBox from 'components/common/SearchBox';
import { STORE_LAYOUT_ELEMENTS } from 'constants/testSelectors';

import CategoryCards from './CategoryCards';

const Container = styled.div<{ show_cards: boolean }>`
  position: relative;
  margin-bottom: ${(props) => (props.show_cards ? '65px' : '')};
`;

const SimpleSearchBanner = styled.div`
  background: ${({ theme }) => theme.colors.brand.primary};
  height: 253px;
  display: flex;
  flex-direction: column;
  padding-top: 59px;
  align-items: center;
`;

const SearchTitle = styled.div`
  color: white;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: 0.25px;
  line-height: 32px;
  padding-bottom: 22px;
`;

const Banner = ({
  categories,
  employee_wallet_id,
  query,
  show_cards,
  onCategoryCardClick,
  setSearchQuery,
}: {
  categories: {
    id: string;
    name: string;
    alias?: string;
  }[];
  employee_wallet_id: string;
  show_cards: boolean;
  query: string;
  onCategoryCardClick: ({
    event,
    category_filter,
  }: {
    event: React.MouseEvent;
    category_filter: string;
  }) => void;
  setSearchQuery: (query: string) => void;
}) => (
  <Container show_cards={show_cards}>
    <SimpleSearchBanner data-testid={STORE_LAYOUT_ELEMENTS.STORE_BANNER_SEARCH}>
      <SearchTitle>
        Use your benefit funds to redeem discounted products.
      </SearchTitle>
      <SearchBox
        label="Search for an item and hit enter"
        query={query}
        setSearchQuery={setSearchQuery}
        hideLabelOnFocus={true}
      />
    </SimpleSearchBanner>
    {show_cards && (
      <CategoryCards
        categories={categories}
        employee_wallet_id={employee_wallet_id}
        onCategoryCardClick={onCategoryCardClick}
      />
    )}
  </Container>
);

export default Banner;
